import { createAsyncThunk } from '@reduxjs/toolkit'
import DataService from "../service";
import { constant } from '../constant'
const { path } = constant;

export const userLogin = createAsyncThunk(
    'user/userLogin',
    (arg, { rejectWithValue }) => DataService.post(arg, path+'users/login', rejectWithValue)
)

export const updateProfile = createAsyncThunk(
    'user/updateProfile',
    (arg, { rejectWithValue }) => DataService.post(arg, path+'users/updateProfile', rejectWithValue)
)

export const changePassword = createAsyncThunk(
    'user/changePassword',
    (arg, { rejectWithValue }) => DataService.post(arg, path+'users/changePassword', rejectWithValue)
)

export const activateUser = createAsyncThunk(
    'user/activateUser',
    (arg, { rejectWithValue }) => DataService.post(arg, path+'users/activateUser', rejectWithValue)
)

export const forgotPassword = createAsyncThunk(
    'user/forgotPassword',
    (arg, { rejectWithValue }) => DataService.post(arg, path+'users/forgotPassword', rejectWithValue)
)

export const updatePassword = createAsyncThunk(
    'user/updatePassword',
    (arg, { rejectWithValue }) => DataService.post(arg, path+'users/updatePassword', rejectWithValue)
)

export const checkToken = createAsyncThunk(
    'user/checkToken',
    (arg, { rejectWithValue }) => DataService.post(arg, path+'users/checkToken', rejectWithValue)
)

export const checkJwtToken = createAsyncThunk(
    'user/checkJwtToken',
    (arg, { rejectWithValue }) => DataService.post(arg, path+'users/checkJwtToken', rejectWithValue)
)